export const ArrowIcon = () => {
  return (
    <svg
      width="57"
      height="50"
      viewBox="0 0 57 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="h-10 w-8 overflow-visible"
    >
      <g
        className={
          'svg-animated-circle -translate-y-1/4 -translate-x-1/4 scale-[1.2] transition-[transform] duration-300 ease'
        }
      >
        <path
          d="M23.4938 49.9619C20.0303 49.7378 17.475 49.1403 15.6772 47.8487C12.8969 45.8535 11.1437 39.6535 16.3205 34.3365C21.8429 28.4174 29.1217 24.415 36.7553 22.7911C42.1573 21.814 47.9212 21.457 53.023 23.4141C59.1371 25.7596 56.5671 32.4825 55.8597 33.8584C52.9933 39.4459 43.3306 44.795 38.6578 46.6005C34.3275 48.3656 28.641 50.2958 23.4938 49.9619Z"
          fill="white"
        />
        <path
          d="M51.7895 28.064C51.2892 26.8688 49.679 25.4608 47.4122 24.9379C45.8349 24.5741 42.6442 24.6391 39.9084 25.0126C33.8052 25.8455 28.1836 28.5234 24.6662 31.0632C22.5674 32.5788 18.4129 35.7692 17.6313 39.5041C17.0208 42.4226 18.3176 44.1018 21.0706 45.2559L21.094 45.2656L21.1175 45.2738C22.4173 45.7566 23.7999 46.0039 25.1946 46.0029H25.3267C26.947 46.0028 28.5607 45.8045 30.1283 45.4128L30.1502 45.4068C37.1809 43.5034 43.6347 40.0242 48.9756 35.2582C49.9914 34.3705 50.8244 33.309 51.4315 32.1284L51.4362 32.1179C52.1663 30.6576 52.289 29.2562 51.7895 28.064Z"
          fill="#1E2532"
        />
        <path
          d="M41.7844 27.7019C43.3477 27.5525 45.888 27.8513 46.665 28.4018C49.679 30.5404 44.8039 34.2007 42.8005 35.6199C37.751 39.1965 35.9657 40.0092 29.9032 41.5958C28.0921 42.0821 24.9788 42.1934 24.0408 41.6705C22.5057 40.8145 21.9937 39.1726 22.8684 37.7115C24.2456 35.3689 26.496 33.5396 28.8089 32.1091C34.1242 28.8224 37.0085 28.1583 41.7844 27.7019ZM39.8459 33.863L38.7164 30.6585Z"
          fill="white"
        />
        <path
          d="M37.1726 31.1381C37.8761 31.0634 39.5957 30.914 40.1429 32.1092C40.4931 32.8741 38.8641 34.2866 38.5796 34.4995C36.3081 36.1929 31.0061 39.2406 29.6641 36.7196C29.2779 35.9935 29.3561 35.1718 31.0757 33.6778C33.3628 31.7409 35.9079 31.2725 37.1726 31.1381Z"
          fill="#1E2532"
        />
      </g>
      <g className="svg-animated-arrow opacity-0 -translate-x-1/4 -translate-y-1/4 duration-300 ease transition-[duration_transform]">
        <path
          d="M23.7554 22.891C14.4839 12.8133 13.2461 11.6373 11.0902 9.5158C7.18535 5.67325 1.95609 6.23608 8.67424 12.9542L20.3205 23.359C20.5635 23.5853 21.0766 23.7371 20.6965 24.391C18.9289 24.0857 17.1361 23.7161 15.3269 23.4692C14.4655 23.3528 13.5099 23.4814 13.3371 24.5817C13.189 25.5344 13.9008 26.0128 14.7012 26.2572C18.0683 27.4092 21.5971 28.009 25.1504 28.0332C27.1791 28.016 27.8628 27.2764 27.7853 25.2084C27.6866 22.519 27.4737 19.832 27.2385 17.1505C27.1535 16.3672 26.9495 15.6008 26.6337 14.8778C26.5151 14.4932 26.2574 14.166 25.9109 13.9604C25.5645 13.7549 25.1544 13.6859 24.761 13.7668C24.364 13.8185 23.9986 14.0089 23.7296 14.3046C23.4605 14.6002 23.3051 14.9819 23.2909 15.3823C23.257 16.1663 23.2981 16.9521 23.4137 17.729C23.6298 19.4518 23.896 21.1747 24.1485 22.9505C23.8586 22.9107 23.7833 22.9189 23.7554 22.891Z"
          fill="#1D264A"
        />
      </g>
    </svg>
  )
}

export default ArrowIcon
